module.exports = __webpack_public_path__ + "static/media/RoastedGranules.87cd1025.pdf";